import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Data Mapping',
  content: `
Data Mapping connects your raw source data (e.g., Snowflake tables, CSV files) to your entities in Pliable's Semantic Layer. Define how columns map to entity attributes and configure transformations for consistency.

# Mapping your Data

1. **Connect a Data Source.**

2. **Clean your data source.**

3. **Map your data source to an entity** through either continuing to Mapping after the cleaning step or going to your entity's node screen and clicking **Connect Data Source**. You'll be able to go back to the Data Mapping Wizard by clicking on Configure and navigating to "Connected Sources" in your entity's node screen.

4. **Drag-and-drop** source columns to the entity's attributes.

5. Click **Done** and/or **Save**.

6. Click **Build**.

7. **Validate Mappings.**
   - Click **View Data** to spot mismatched data types or unmapped columns.
   - Make sure your data was mapped correctly.

> 📎  You can use the **Map with AI** button and Pliable will automatically map the best columns from your data source to your entity.

# Use Cases

- **Schema Harmonization**: Map differently named columns (e.g., \`cust_id\` to \`customer_id\`) to a single entity.
- **Legacy Data Integration**: Transform outdated formats (e.g., \`MM/DD/YY\` to \`YYYY-MM-DD\`).

# Common Issues

- **Unmapped Columns**: Columns not mapped to an entity will not appear in reports.
- **Calculated Columns**: Columns that are calculated will not be able to be mapped to.
- **Type Mismatches**: Ensure numeric source columns map to numeric entity attributes.
`,
};

export default doc;
